export var BackgroundType = /*#__PURE__*/ function(BackgroundType) {
    BackgroundType["NONE"] = "none";
    BackgroundType["SOLID"] = "solid";
    BackgroundType["GRADIENT"] = "gradient";
    BackgroundType["PATTERN"] = "pattern";
    BackgroundType["IMAGE"] = "image";
    return BackgroundType;
}({});
export var BackgroundImageDisplayMode = /*#__PURE__*/ function(BackgroundImageDisplayMode) {
    BackgroundImageDisplayMode["TILE"] = "tile";
    BackgroundImageDisplayMode["COVER"] = "cover";
    BackgroundImageDisplayMode["CONTAIN"] = "contain";
    return BackgroundImageDisplayMode;
}({});

//# sourceMappingURL=types.js.map